import React from 'react';

const ComparisonBarChart = ({ imageData }) => {
  if (!imageData) return null;

  // Use size_in_mb for accurate calculations
  const koalaSize = imageData.koala.size_in_mb;
  const dockerhubSize = imageData.dockerhub.size_in_mb;
  const koalaPackages = imageData.koala.sbom.totalPackages;
  const dockerhubPackages = imageData.dockerhub.sbom.totalPackages;

  // Calculate percentages for bar widths
  const maxSize = Math.max(koalaSize, dockerhubSize);
  const maxPackages = Math.max(koalaPackages, dockerhubPackages);

  const sizeData = [
    {
      label: 'KoalaLab',
      value: koalaSize,
      displayValue: imageData.koala.size,
      percentage: (koalaSize / maxSize) * 100,
      color: '#EB1C45'
    },
    {
      label: 'Alternative',
      value: dockerhubSize,
      displayValue: imageData.dockerhub.size,
      percentage: (dockerhubSize / maxSize) * 100,
      color: '#666666'
    }
  ];

  const packageData = [
    {
      label: 'KoalaLab',
      value: koalaPackages,
      displayValue: koalaPackages,
      percentage: (koalaPackages / maxPackages) * 100,
      color: '#EB1C45'
    },
    {
      label: 'Alternative',
      value: dockerhubPackages,
      displayValue: dockerhubPackages,
      percentage: (dockerhubPackages / maxPackages) * 100,
      color: '#666666'
    }
  ];

  const BarChartSection = ({ title, data, unit = '' }) => (
    <div className="bar-chart-section">
      <h3 className="chart-title-left">{title}</h3>
      <div className="bar-chart">
        {data.map((item, index) => (
          <div key={index} className="bar-row">
            <div className="bar-label">{item.label}</div>
            <div className="bar-container">
              <div 
                className="bar"
                style={{ 
                  width: `${item.percentage}%`,
                  backgroundColor: item.color
                }}
              />
            </div>
            <div className="bar-value">{item.displayValue}{unit}</div>
          </div>
        ))}
      </div>
    </div>
  );

  // Critical + High CVEs since accumulation date data
  let cveSinceData = null;
  if (imageData.cve_accumulation_since) {
    const accumulationDate = new Date(imageData.cve_accumulation_since);
    const koalaCVEsSince = imageData.koala.cves.filter(cve => 
      new Date(cve.publishedDate) >= accumulationDate && 
      (cve.severity === 'CRITICAL' || cve.severity === 'HIGH')
    ).length;
    const dockerhubCVEsSince = imageData.dockerhub.cves.filter(cve => 
      new Date(cve.publishedDate) >= accumulationDate && 
      (cve.severity === 'CRITICAL' || cve.severity === 'HIGH')
    ).length;
    const maxCVEsSince = Math.max(koalaCVEsSince, dockerhubCVEsSince);
    
    cveSinceData = [
      {
        label: 'KoalaLab',
        value: koalaCVEsSince,
        displayValue: koalaCVEsSince,
        percentage: maxCVEsSince > 0 ? (koalaCVEsSince / maxCVEsSince) * 100 : 0,
        color: '#EB1C45'
      },
      {
        label: 'Alternative',
        value: dockerhubCVEsSince,
        displayValue: dockerhubCVEsSince,
        percentage: maxCVEsSince > 0 ? (dockerhubCVEsSince / maxCVEsSince) * 100 : 0,
        color: '#666666'
      }
    ];
  }

  return (
    <div className="comparison-bar-charts">
      {!imageData.cve_accumulation_since && (
        <BarChartSection 
          title="Image Size" 
          data={sizeData}
        />
      )}
      <BarChartSection 
        title="Total Packages" 
        data={packageData}
        unit=" packages"
      />
      {cveSinceData && (
        <BarChartSection 
          title={`Critical+High CVEs Since ${new Date(imageData.cve_accumulation_since).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}`}
          data={cveSinceData}
          unit=" CVEs"
        />
      )}
    </div>
  );
};

export default ComparisonBarChart;